const CheckBoxIcon = ({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
      <rect
        width={18.75}
        height={18.75}
        x={0.625}
        y={0.625}
        stroke="#999999"
        strokeWidth={1.25}
        rx={1.875}
      />
    </svg>
  )
}

export default CheckBoxIcon
